import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import Header from "./components/Header";
import Landing from "./pages/Landing";
import SubmitTicket from "./pages/SubmitTicket";
import TrackTicket from "./pages/TrackTicket";
import AgentLogin from "./pages/AgentLogin";
import Register from "./pages/Register";
import MyTickets from "./pages/MyTickets";
import MyTicketDetail from "./pages/MyTicketDetail";
import AgentWorkspace from "./pages/AgentWorkspace";
import AdminAgents from "./pages/AdminAgents";
import AdminUsers from "./pages/AdminUsers";
import AdminSettings from "./pages/AdminSettings";
import AdminGmail from "./pages/AdminGmail";
import Subscriptions from "./pages/Subscriptions";
import Reminders from "./pages/Reminders";
import AdminApiKeys from "./pages/AdminApiKeys";
import PublicApiDocs from "./pages/PublicApiDocs";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <div className="App min-h-screen bg-slate-50 text-slate-900">
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/track" element={<TrackTicket />} />
              <Route path="/docs/api" element={<PublicApiDocs />} />
              <Route path="/login" element={<AgentLogin />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/submit"
                element={
                  <ProtectedRoute>
                    <SubmitTicket />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-tickets"
                element={
                  <ProtectedRoute>
                    <MyTickets />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-tickets/:id"
                element={
                  <ProtectedRoute>
                    <MyTicketDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/workspace"
                element={
                  <ProtectedRoute staffOnly>
                    <AgentWorkspace />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/agents"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminAgents />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/users"
                element={
                  <ProtectedRoute staffOnly>
                    <AdminUsers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/settings"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminSettings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/subscriptions"
                element={
                  <ProtectedRoute staffOnly>
                    <Subscriptions />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reminders"
                element={
                  <ProtectedRoute staffOnly>
                    <Reminders />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/api-keys"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminApiKeys />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/gmail"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminGmail />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
